import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import { Box, Typography } from '@mui/material';

import useProfileImages from 'app/hooks/useProfileImages';
import { getUserFromContactSelector } from 'app/features/chat/nfChatSlice';

const AvatarWithStatus = ({ contact }) => {
  if (!contact) return null;

  if (contact.other_user.is_advisor) {
    const advisor = useSelector((state) => {
      return getUserFromContactSelector(state, contact.other_user.id);
    });

    const { acceptedAvatarImage: avatarImage } = useProfileImages(advisor);

    return (
      <Box
        sx={{
          // these taken from nfp-avatar-post class
          backgroundImage: `url('${avatarImage}')`,
          WebkitBackgroundSize: 'cover',
          OBackgroundSize: 'cover',
          backgroundSize: 'cover',
          backgroundPosition: 'top center',
          backgroundAttachment: 'initial',
          width: '50px',
          height: '50px',
          overflow: 'hidden',
          borderRadius: '50%',
          backgroundColor: '#ccc',
        }}
      />
    );
  } else {
    return (
      <Box
        sx={{
          borderRadius: '2px',
          backgroundColor: 'rgb(238, 238, 238)',
          width: '50px !important',
          height: '50px !important',
        }}
      >
        <Typography
          sx={{
            textTransform: 'lowercase',
            fontSize: '24px',
            fontWeight: 400,
            letterSpacing: '1px',
            color: 'rgb(153, 153, 153)',
            textAlign: 'center',
            paddingTop: '0.35em',
          }}
        >
          {contact.other_user.name.substring(0, 2).toUpperCase()}
        </Typography>
      </Box>
    );
  }
};

AvatarWithStatus.defaultProps = {
  contact: null,
};

AvatarWithStatus.propTypes = {
  contact: PropTypes.object,
};

export default AvatarWithStatus;
